import { render, staticRenderFns } from "./DoorImpacts.vue?vue&type=template&id=6879765c&scoped=true"
import script from "./DoorImpacts.vue?vue&type=script&lang=ts"
export * from "./DoorImpacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6879765c",
  null
  
)

export default component.exports